import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

/**
 * The single sign-on entry point.
 *
 * MI apps present one SSO affordance — "Login by MiGlobal" — which starts the
 * Nextcloud OIDC flow (stack §7). There is deliberately no username/password
 * form anywhere in this app: it stores no passwords, and offering a local login
 * box would imply an account that does not exist.
 */
export function SsoButton({
  returnTo,
  className,
  size = "lg",
}: {
  returnTo?: string;
  className?: string;
  size?: "default" | "sm" | "lg";
}) {
  const { t } = useTranslation();
  const href = returnTo ? `/auth/login?returnTo=${encodeURIComponent(returnTo)}` : "/auth/login";

  return (
    <Button asChild size={size} className={className}>
      <a href={href}>
        <MiGlobalMark />
        {t("auth:loginByMiGlobal")}
      </a>
    </Button>
  );
}

/** Small inline mark so the SSO button reads as an identity action, not a link. */
function MiGlobalMark() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden focusable="false">
      <title>MiGlobal</title>
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M3.6 9.5h16.8M3.6 14.5h16.8M12 3.2c2.6 2.4 4 5.5 4 8.8s-1.4 6.4-4 8.8c-2.6-2.4-4-5.5-4-8.8s1.4-6.4 4-8.8z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}
